import { PHOTO_EFFECT_DEFINITIONS } from '@/lib/photo-effects/photo-effect-defs'
import {
  PEZ_ADJUSTABLE_ROW_HEIGHT,
  PEZ_BINARY_ROW_HEIGHT,
  PEZ_EFFECTS_VIEW_DEFAULT_HEIGHT,
  PEZ_EFFECTS_VIEW_MIN_HEIGHT,
} from '@/components/app/photos/photo-effects/constants/photo-effect-row-layout'

/** Full scrollable content height for every catalog row (max expand). */
export function computePezListViewportMaxHeight(): number {
  let total = 0

  for (const def of PHOTO_EFFECT_DEFINITIONS) {
    total += def.kind === 'binary' ? PEZ_BINARY_ROW_HEIGHT : PEZ_ADJUSTABLE_ROW_HEIGHT
  }

  return total
}

/** Clamp user-resized list viewport height between Figma min and full list height. */
export function clampPezListViewportHeight(height: number): number {
  return Math.min(
    computePezListViewportMaxHeight(),
    Math.max(PEZ_EFFECTS_VIEW_MIN_HEIGHT, Math.round(height))
  )
}

/** Figma default — seven binary rows plus a sliver of the eighth row. */
export function getPezDefaultListViewportHeight(): number {
  return PEZ_EFFECTS_VIEW_DEFAULT_HEIGHT
}
